<script setup lang="ts">
import { OverageListInterface } from '@/types';
import { toRefs } from 'vue';
import SeatChip from './SeatChip.vue';

interface Props {
  overage: OverageListInterface;
}

const props = defineProps<Props>();

const { overage } = toRefs(props);
</script>

<template>
  <div class="flex w-full align-content-center font-bold justify-content-between">
    <h2 class="align-content-center">{{ overage.discipline.name }}</h2>
    <div class="py-1 surface-100 border-round-xl flex gap-2 align-items-center justify-content-end">
      <SeatChip title="Contracted" text-color="text-color-black" :text="overage.seats" />
      <SeatChip title="Total" text-color="text-color-red" :text="overage.completed_count + overage.scheduled_count" />
      <SeatChip title="Completed" text-color="text-color-blue" :text="overage.completed_count" />
      <SeatChip title="Scheduled" text-color="text-color-orange" :text="overage.scheduled_count" />
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
